import React, { useState } from 'react';
import { API_URL } from '../../api-config';

const UserCreate = () => {
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    const token = localStorage.getItem('token'); // Asume que el token está almacenado en localStorage

    try {
      const response = await fetch(`${API_URL}/users-api/users/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ email, username, password }),
      });

      if (response.ok) {
        setSuccess('User Usercreated successfully!');
        window.alert('User created successfully!');
        setEmail('');
        setUsername('');
        setPassword('');
      } else {
        const data = await response.json();
        setError(data.detail || 'Failed to create user');
      }
    } catch (err) {
      setError('An error occurred');
    }
  };

  return (
    <div className="flex items-center justify-center p-12 bg-[#101523]">
      <div className="w-full max-w-md p-8 space-y-6  rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-center">Create User</h2>
        {error && <div className="p-2 mb-4 text-sm text-red-700 bg-red-200 rounded">{error}</div>}
        {success && <div className="p-2 mb-4 text-sm text-green-700 bg-green-200 rounded">{success}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-white">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 mt-1 text-gray-900 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-white">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-3 py-2 mt-1 text-gray-900 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-white">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 mt-1 text-gray-900 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full px-4 py-2 text-white bg-blue-500 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
          >
            Create User
          </button>
        </form>
      </div>
    </div>
  );
};

export default UserCreate;
